<div class="top-prompt-dialog">
  <div class="dialog-header">
    <div class="header-content">
      <span class="platform-icon" [attr.aria-label]="getPlatformLabel(item.platform)">
        <img *ngIf="item.platform === 'chatgpt'" src="/images/logo/chatgpt.png" alt="ChatGPT" />
        <img *ngIf="item.platform === 'gemini'" src="/images/logo/gemini.jpg" alt="Gemini" />
        <svg *ngIf="item.platform === 'ai_overview'" width="24" height="24" viewBox="0 0 24 24" aria-label="AI Overview">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        <svg *ngIf="item.platform === 'ai_mode'" width="24" height="24" viewBox="0 0 24 24" aria-label="AI Mode">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        <span *ngIf="item.platform !== 'chatgpt' && item.platform !== 'gemini' && item.platform !== 'ai_overview' && item.platform !== 'ai_mode'" class="platform-fallback">{{ getPlatformLabel(item.platform) }}</span>
      </span>
      <h2 mat-dialog-title class="prompt-title">{{ item.query || 'Prompt' }}</h2>
    </div>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="layout">
      <div class="main">
        <div class="block prompt-block">
          <h3 class="block-title">Prompt</h3>
          <p class="prompt-text">{{ item.query }}</p>
        </div>
        <div class="block response-block">
          <h3 class="block-title">Response</h3>
          <div class="response-text" [innerHTML]="formatResponse(item.answer_text)"></div>
        </div>
      </div>
      <aside class="sidebar">
        <div class="block mentions-block" *ngIf="(item.cited_domains?.length || item.mentioned_brands.length)">
          <h3 class="block-title">Mentions</h3>
          <div class="mention-chips">
            <ng-container *ngIf="item.cited_domains?.length">
              <img *ngFor="let dom of item.cited_domains" [src]="getFaviconUrl(dom)" alt="" class="mention-domain-favicon" [title]="dom" (error)="onFaviconError($event)" />
            </ng-container>
            <span *ngFor="let brandName of item.mentioned_brands" class="mention-chip" [title]="brandName">
              <span class="mention-chip-initial">{{ getBrandInitial(brandName) }}</span>
              <span class="mention-chip-name">{{ brandName }}</span>
            </span>
          </div>
        </div>
        <div class="block citations-block">
          <h3 class="block-title">Citations</h3>
          <app-citation-card
            *ngIf="formatCitations(item.citations || []).length > 0"
            [citations]="formatCitations(item.citations)"
            [title]="'Sources'"
            [displayStyle]="'list'"
            [maxDisplay]="20">
          </app-citation-card>
          <p class="empty" *ngIf="formatCitations(item.citations || []).length === 0">No citations</p>
        </div>
      </aside>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onClose()">Close</button>
  </mat-dialog-actions>
</div>
